<ion-app>
    <ion-menu side="start" menuId="main-menu" contentId="main" swipe-gesture="false">
        <ion-header>
            <ion-toolbar>
                <ion-title class="ion-text-center">Menu</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <ion-list>
                <ion-item button (click)="onFileClick()" [disabled]="isLoading" lines="none">
                    <ion-icon slot="start" name="document-outline"></ion-icon>
                    <ion-label>Load Log File</ion-label>
                    @if (isLoading) {
                        <ion-spinner slot="end" name="crescent"></ion-spinner>
                    } @else {
                        <span slot="end" style="font-size: 0.85em; opacity: 0.55; font-variant-numeric: tabular-nums"
                            >{{ shortcutPrefix }}O</span
                        >
                    }
                </ion-item>
                <input
                    #fileInput
                    class="file-input"
                    type="file"
                    [accept]="fileInputAccept"
                    (change)="onFileInputChange($event)"
                    style="display: none"
                />

                <ion-item button (click)="openSignalsModal()" lines="none">
                    <ion-icon slot="start" name="layers-outline"></ion-icon>
                    <ion-label>Signal Setup</ion-label>
                </ion-item>

                <ion-item button (click)="openCalculatedSignalsPage()" lines="none">
                    <ion-icon slot="start" name="calculator-outline"></ion-icon>
                    <ion-label>Calculated Signals</ion-label>
                </ion-item>

                <div style="height: 1px; background-color: var(--ion-color-step-150, #ccc); margin: 8px 16px"></div>

                <ion-item button (click)="loadConfiguration()" [disabled]="!hasConfigurations" lines="none">
                    <ion-icon slot="start" src="assets/icons/open.svg"></ion-icon>
                    <ion-label>Load Configuration</ion-label>
                </ion-item>

                <ion-item button (click)="saveConfiguration()" [disabled]="!isLoaded()" lines="none">
                    <ion-icon slot="start" src="assets/icons/download.svg"></ion-icon>
                    <ion-label>Save Configuration</ion-label>
                    <span slot="end" style="font-size: 0.85em; opacity: 0.55; font-variant-numeric: tabular-nums"
                        >{{ shortcutPrefix }}S</span
                    >
                </ion-item>

                <ion-item button (click)="openConfigurationsModal()" [disabled]="!hasConfigurations" lines="none">
                    <ion-icon slot="start" src="assets/icons/folder_filled.svg"></ion-icon>
                    <ion-label>Manage Configurations</ion-label>
                </ion-item>

                <ion-item button (click)="backupConfigurations()" [disabled]="!hasConfigurations" lines="none">
                    <ion-icon slot="start" src="assets/icons/download.svg"></ion-icon>
                    <ion-label>Backup Configurations</ion-label>
                </ion-item>

                <ion-item button (click)="onRestoreClick()" lines="none">
                    <ion-icon slot="start" src="assets/icons/open.svg"></ion-icon>
                    <ion-label>Restore Configurations</ion-label>
                </ion-item>
                <input #configFileInput type="file" accept=".json" style="display: none" (change)="restoreConfigurations($event)" />

                <div style="height: 1px; background-color: var(--ion-color-step-150, #ccc); margin: 8px 16px"></div>

                <ion-item button (click)="openSettingsModal()" lines="none">
                    <ion-icon slot="start" name="settings-outline"></ion-icon>
                    <ion-label>Settings</ion-label>
                    @if (updateAvailable) {
                        <ion-badge color="primary" slot="end">!</ion-badge>
                    }
                    <span slot="end" style="font-size: 0.85em; opacity: 0.55; font-variant-numeric: tabular-nums"
                        >{{ shortcutPrefix }},</span
                    >
                </ion-item>

                <ion-item button (click)="openHelpPage()" lines="none">
                    <ion-icon slot="start" name="help-circle-outline"></ion-icon>
                    <ion-label>Help</ion-label>
                    <span slot="end" style="font-size: 0.85em; opacity: 0.55; font-variant-numeric: tabular-nums">F1</span>
                </ion-item>

                <div style="height: 1px; background-color: var(--ion-color-step-150, #ccc); margin: 8px 16px"></div>

                <ion-item lines="none">
                    <ion-label class="ion-text-wrap" style="font-size: 0.85em; opacity: 0.8; padding-bottom: 16px">
                        <strong>HGM Charts</strong><br />
                        Version {{ appVersion }}<br />
                        {{ appHash }}<br />
                        {{ browserPlatformString }}<br /><br />
                        Copyright &copy; 2017-2026<br />
                        HGM Automotive Electronics, Inc.<br />
                        All rights reserved.
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ion-menu>
    <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>
